import React, { useEffect, useState } from "react";
import moment from "moment";
import { CapsuleTabs, PageIndicator } from "antd-mobile-v5";
import { createFromIconfontCN } from "@ant-design/icons";
import type { RouteComponentProps } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./reportRecord.scss";
import { ApiCore } from "../../api";
import utils from "../../utils/utils";
import record from "../../static/icon/record.svg";
import backBtn from "../../static/icon/back_button.png";

const api = new ApiCore();
//设置阿里图库地址
const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_2343612_adf3x9c88m9.js",
});

interface VisitItem {
  id: string;
  name: string;
  state: string;
  visitDate: string;
}

interface RecordItem {
  scalaServerRecordId: string;
  restatementState: number;
  createTime: string;
}

const ReportRecord = (props: RouteComponentProps<{ scaleCode: string; subjectCode: string }>) => {
  const urlParams = utils.getUrlParams();
  const { scaleCode, subjectCode } = props.match.params;
  const [visitList, setVisitList] = useState<VisitItem[]>([]);
  const [currentVisitIndex, setCurrentVisitIndex] = useState<number>(-1);
  const [visitId, setVisitId] = useState<string | null>(null);
  const [recordList, setRecordList] = useState<RecordItem[]>([]);
  const [currentRecordId, setCurrentRecordId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  //悬浮按钮项相关
  let oLeft: any;
  let oTop: any;
  let moving: boolean = false;
  let oW: any;
  let oH: any;
  let htmlWidth: any;
  let htmlHeight: any;
  let bWidth: any;
  let bHeight: any;
  let click: boolean = false;
  useEffect(() => {
    let ele = document.getElementById("t-suspend-button");
    let recordStateLocal = localStorage.getItem("recordState");
    if (ele) {
      if (recordStateLocal) {
        let recordState = JSON.parse(recordStateLocal);
        ele.style.left = recordState.actionBall.left;
        ele.style.top = recordState.actionBall.top;
      }
      ele.addEventListener(
        "touchmove",
        (e) => {
          if (e.cancelable) {
            e.preventDefault();
          }
        },
        {
          passive: false,
        }
      );
    }
  }, []);
  //当开始触摸
  const onTouchStart = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = true;
    if (ele) {
      ele.style.opacity = "1";
      oW = e.clientX - ele?.getBoundingClientRect().left;
      oH = e.clientY - ele?.getBoundingClientRect().top;
      htmlWidth = document.documentElement.clientWidth;
      htmlHeight = document.documentElement.clientHeight;
      bWidth = ele.offsetWidth;
      bHeight = ele.offsetHeight;
      oLeft = e.clientX - oW;
      oTop = e.clientY - oH;

      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
      moving = true;
    }
  };

  //当触摸结束
  const onTouchEnd = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    moving = false;

    // 左侧距离
    let oLeft1 = oLeft;
    if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
      oLeft1 = 0;
    } else {
      oLeft1 = `${htmlWidth - bWidth}px`;
    }
    oLeft = oLeft1;
    if (ele) {
      ele.style.left = oLeft;
      let recordState = {
        actionBall: {
          left: ele.style.left,
          top: ele.style.top,
        },
      };
      localStorage.setItem("recordState", JSON.stringify(recordState));
      setTimeout(() => {
        if (ele) {
          ele.style.opacity = "0.8";
        }
      }, 2000);
    }
  };

  // 当开始触摸
  const onTouchMove = (e: any) => {
    moving && onMove(e);
  };

  // 当触摸
  const onMove = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = false;

    // 左侧距离
    let oLeft1 = e.clientX - oW;
    let oTop1 = e.clientY - oH;
    if (oLeft1 < 0) {
      oLeft1 = 0;
    } else if (oLeft1 > htmlWidth - bWidth) {
      oLeft1 = htmlWidth - bWidth;
    }
    if (oTop1 < 0) {
      oTop1 = 0;
    } else if (oTop1 > htmlHeight - bHeight) {
      oTop1 = htmlHeight - bHeight;
    }
    oLeft = oLeft1;
    oTop = oTop1;
    if (ele) {
      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
    }
  };

  useEffect(() => {
    document.title = `${urlParams.scaleName}(${scaleCode})`;
    getReportDetail(scaleCode, subjectCode);
  }, []);

  // 格式化时间
  const handleFormatDate = (date: Date) => {
    if (!date) return;
    return moment(date).format("YYYY-MM-DD HH:mm");
  };

  // 获取患者自报记录
  const getReportDetail = async (scaleCode: string, subjectCode: string) => {
    const { data } = await api.getVisitsByScaleCode({ scaleCode, subjectCode });
    const visitList: VisitItem[] = (data ?? []).map(({ id, ...reset }: VisitItem) => ({
      ...reset,
      id: id.toString(),
    }));
    const visitObj = visitList[0];
    setVisitList(visitList);
    setVisitId(() => {
      getRecord(visitObj?.id, scaleCode);
      const currentIndex = visitList.findIndex((v) => v.id === visitObj?.id);
      setCurrentVisitIndex(currentIndex);
      return visitObj?.id;
    });
  };

  // 获取受试者填报问卷记录
  const getRecord = async (visitId: string, scaleCode: string) => {
    if (!visitId) return;
    try {
      const { data } = await api.getReportedById({ scaleCode, visitId });
      const tempList = (data ?? []).map(({ createTime, ...reset }: any) => ({
        ...reset,
        createTime: handleFormatDate(createTime),
      }));
      const recordObj = tempList[0];
      setRecordList(tempList);
      if (tempList?.length) {
        changeRecordId(recordObj?.scalaServerRecordId);
      } else {
        changeRecordId(null);
      }
    } finally {
    }
  };

  // 切换量表下的记录ID
  const changeRecordId = (id: string | null) => {
    // setLoading(true)
    setCurrentRecordId(id);
  };

  const handleVisitChange = (visitId: string) => {
    const currentIndex = visitList.findIndex((v) => v.id === visitId);
    setVisitId(visitId);
    setCurrentVisitIndex(currentIndex);
    getRecord(visitId, scaleCode);
  };

  const goScaleIfram = (type: 'pgwj' | 'pgjg', recordId: string) => {
    props.history.push(`/eproScaleIframe/${scaleCode}/${recordId}/${type}`)
  }

  const tabTitle: React.FC<VisitItem> = (props) => {
    return (
      <div className="scale-item--container">
        <div className="scale-item--title">{props.name}</div>
        <div className="scale-item--date">{props.visitDate}</div>
        <div className="scale-item--icon">
          {props.state === "Wait" && <IconFont type="iconvisitWait"></IconFont>}
          {props.state === "Running" && <IconFont type="iconjinhangzhongxiangmu"></IconFont>}
          {props.state === "Complete" && <IconFont type="iconvisitComplete"></IconFont>}
          {props.state === "Lose" && <IconFont type="iconvisitLose"></IconFont>}
        </div>
      </div>
    );
  };

  return (
    <div className="record-container">
      <div className="record-scale">
        <CapsuleTabs activeKey={visitId} onChange={handleVisitChange}>
          {visitList.map((v) => (
            <CapsuleTabs.Tab title={tabTitle(v)} key={v.id} />
          ))}
        </CapsuleTabs>
        {visitList?.length > 0 && (
          <PageIndicator
            total={visitList.length}
            current={currentVisitIndex}
            className="record-scale--page"
            style={{
              "--dot-color": "rgba(0, 0, 0, 0.15)",
              "--active-dot-color": "#6c96f7",
              "--dot-size": "10px",
              "--active-dot-size": "30px",
              "--dot-border-radius": "50%",
              "--active-dot-border-radius": "15px",
              "--dot-spacing": "8px",
            }}
          />
        )}
      </div>
      {recordList.map((r) => (
        <div className="record-item">
          <div className="record-item--left">
            <img src={record} alt="file" />
            <span>{r.createTime}</span>
          </div>
          <div className="record-item--right">
            <span onClick={() => goScaleIfram('pgwj', r.scalaServerRecordId)}>评估问卷</span>
            <span onClick={() => goScaleIfram('pgjg', r.scalaServerRecordId)}>评估结果</span>
          </div>
        </div>
      ))}

      <div
        className="addAction"
        id="t-suspend-button"
        onTouchStart={(e) => onTouchStart(e)}
        onTouchMove={(e) => onTouchMove(e)}
        onTouchEnd={(e) => onTouchEnd(e)}
      >
        <img
          src={backBtn}
          alt="back"
          onClick={() => {
            props.history.go(-1);
          }}
        />
      </div>
    </div>
  );
};

/**
 * 
 *             <iframe
              src={`https://scale-saas.huimeihealth.com.cn/evaluation/${currentTpl.code}`}
              height="100%"
              width="100%"
              id="pgwj"
              title="评估问卷"
            ></iframe>

                        <iframe
              src={`https://scale-saas.huimeihealth.com.cn/report/${currentRecordId}/${currentTpl.code}`}
              onLoad={handleLoadIframe}
              height="100%"
              width="100%"
              id="pgjg"
              title="评估结果"
            ></iframe>
 */

export default withRouter(ReportRecord);
